import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Splash from './pages/splash';
import Auth from './pages/auth/index';
import ForgotPassword from './pages/auth/forgot-password';
import VerifyCode from './pages/auth/verify-code';
import PasswordResetConfirm from './pages/auth/password-reset-confirm';
import NewPassword from './pages/auth/new-password';
import PasswordUpdated from './pages/auth/password-updated';
import SignUp from './pages/signup';
import Onboarding from './pages/onboarding';
import ClientDashboard from './pages/ClientDashboard';
import CreateChildProfile from './pages/CreateChildProfile';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminMilestones from './pages/AdminMilestones';
import ManageBands from './pages/ManageBands';
import AdminWeeklyQuestions from './pages/AdminWeeklyQuestions';
import AdminRecommendedActivities from './pages/AdminRecommendedActivities';
import MilestonesStatus from './pages/MilestonesStatus';
import ChildProfile from './pages/ChildProfile';
import CongratsPage from './components/CongratsPage';
import WeeklyChecklist from "./pages/WeeklyChecklist";
import RecommendedActivities from "./pages/RecommendedActivities";
import TrackProgress from "./pages/TrackProgress";
import AlertsReminders from "./pages/AlertsReminders";
import QuestionAnswer from "./pages/QuestionAnswer";
import TufyLanding from "./components/TufyLanding";
import Tufychatcenter from "./components/Tufychatcenter";
import AlertDetails from "./components/AlertDetails";
import AddReminder from "./components/AddReminder";
import ReminderDetails from "./components/ReminderDetails";
import TalkToExpert from "./pages/TalkToExpert";
import AdminConcern from "./pages/AdminConcern";
import AdminExpertManager from "./pages/AdminExpertManager";
import CommunityChat from "./pages/CommunityChat";
import CommunityQuestionDetail from "./pages/CommunityQuestionDetail";
import FAQs from './pages/FAQs';
import About from './pages/About';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MediaAnalysis from './pages/MediaAnalysis';
import PregnancyStageDetail from './pages/PregnancyStageDetail';
import AdminPregnancyTasks from './pages/AdminPregnancyTasks';
import TestServices from './pages/TestServices';

function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<LandingPage />} />
        <Route path="/splash" element={<Splash />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/verify-code" element={<VerifyCode />} />
        <Route path="/auth/password-reset-confirm" element={<PasswordResetConfirm />} />
        <Route path="/auth/new-password" element={<NewPassword />} />
        <Route path="/auth/password-updated" element={<PasswordUpdated />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        <Route path="/create-child-profile" element={<CreateChildProfile />} />
        <Route path="/edit-child-profile/:childId" element={<CreateChildProfile />} />
        <Route path="/child/:childId/milestones-status" element={<MilestonesStatus />} />
        <Route path="/child/:childId" element={<ChildProfile />} />
        <Route path="/congrats" element={<CongratsPage />} />
        <Route path="/weekly-checklist/:childId" element={<WeeklyChecklist />} />
        <Route path="/recommended-activities/:childId" element={<RecommendedActivities />} />
        <Route path="/track-progress/:childId" element={<TrackProgress />} />
        <Route path="/alerts-reminders/:childId" element={<AlertsReminders />} />
        <Route path="/question-answer/:childId" element={<QuestionAnswer />} />
        <Route path="/pregnancy/:childId" element={<PregnancyStageDetail />} />
        <Route path="/tufy-landing/:childId" element={<TufyLanding />} />
        <Route path="/tufy-chat-center/:childId" element={<Tufychatcenter />} />
        <Route path="/talk-to-expert/:childId" element={<TalkToExpert />} />
        <Route path="/CommunityChat/:childId" element={<CommunityChat />} />
        <Route path="/community/question/:questionId" element={<CommunityQuestionDetail />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/add-reminder/:childId" element={<AddReminder />} />
        <Route path="/alert-details/:childId" element={<AlertDetails />} />
        <Route path="/reminder-details/:childId" element={<ReminderDetails />} />
        <Route path="/media-analysis/:childId" element={<MediaAnalysis />} />
        
        <Route path="/admin-dashboard" element={<AdminDashboard />}>
          <Route index element={<div>Dashboard Content</div>} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="milestones" element={<AdminMilestones />} />
          <Route path="manage-bands" element={<ManageBands />} />
          <Route path="manage-weekly-checklist" element={<AdminWeeklyQuestions />} />
          <Route path="manage-recommended-activities" element={<AdminRecommendedActivities />} />
          <Route path="admin-concern" element={<AdminConcern />} />
          <Route path="expert-manager" element={<AdminExpertManager />} />
          <Route path="pregnancy-tasks" element={<AdminPregnancyTasks />} />
          <Route path="test-services" element={<TestServices />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
